import { Button } from "./ui/Button.js";

/** Shown at the top of an editor when sessionStorage holds unsaved edits from an
 *  earlier visit that differ from what is currently saved. */
export function DraftRestoreBar({
  onRestore,
  onDiscard,
}: {
  onRestore: () => void;
  onDiscard: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <p>You have unsaved changes on this page from an earlier visit.</p>
      <div className="flex items-center gap-2">
        <Button type="button" variant="ghost" size="sm" onClick={onDiscard}>
          Discard
        </Button>
        <Button type="button" variant="secondary" size="sm" onClick={onRestore}>
          Restore changes
        </Button>
      </div>
    </div>
  );
}
